module.exports = __webpack_public_path__ + "static/images/businessLicenseExample.a38d882.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/businessLicenseExample.jpg
// module id = jPys
// module chunks = 0